import { render, staticRenderFns } from "./CncPagination.vue?vue&type=template&id=dede39ec"
import script from "./CncPagination.vue?vue&type=script&lang=js"
export * from "./CncPagination.vue?vue&type=script&lang=js"
import style0 from "./CncPagination.vue?vue&type=style&index=0&id=dede39ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports